import { createAction } from "@reduxjs/toolkit";
import { SHOW_TOAST,CLEAR_TOAST } from "./types";

export const showToast = ({message, type}:{message:string, type:string}) => ({
  type: SHOW_TOAST,
  payload: { message, type },
});

export const clearToast = createAction(CLEAR_TOAST);
